export enum OutsetaAudEnum {
  USA = 'jooice.outseta.com',
  ITA = 'jooice-it.outseta.com',
  MEA = 'jooice-mea.outseta.com',
  SPARTACUS = 'jooice-spartacus.outseta.com',
}

export enum OutsetaCountryEnum {
  USA = 'usa',
  ITA = 'ita',
  MEA = 'mea',
  SPARTACUS = 'spartacus',
}

export enum JooiceAuthVersion {
  USA = 'usa',
  ITA = 'ita',
  MEA = 'mea',
}

export const domainByCountry = {
  usa: 'jooice.outseta.com',
  ita: 'jooice-it.outseta.com',
  mea: 'jooice-mea.outseta.com',
  spartacus: 'jooice-spartacus.outseta.com',
};
